import { api as apiRequest } from '@culture/common-helpers/request';

export const fulfillInteractive = async (
	result,
	interactiveId,
	publicationId
) => {
	const params = {
		result,
		interactive: interactiveId,
		publication: publicationId
	};

	return apiRequest('interactiveResults', params, 'POST');
};
